import "./ChatSelector.css";
import { useState } from "react";
import {cancelOngoingOperations} from "../../../Chat/utilsLogic/utils"
import {useAppContext} from "../../../../../AppDataContext";
interface ChatSelectorProps {
  startNewChat?: () => void;
  collapsed?: boolean; // Optional boolean
}

const ChatSelector: React.FC<ChatSelectorProps> = ({ startNewChat, collapsed }) => {
  const [hideDays, setHideDays] = useState<boolean>(false);
  const toggleDaysVisibility = () => {
    setHideDays(!hideDays);
  };
   const AppDataContext =  useAppContext()
   const locale_messages = new Map<string, any>(Object.entries(require('../../../../../ds/locale.json')));
   const languageKey = AppDataContext.language_for_chat || "EN";
   const newChatCaption = locale_messages.get(languageKey)?.new_chat;
   const handleNewChatClick = async () => {

     await cancelOngoingOperations(true);
     // Check if errorbtn exists on the page
     const errorBtnTitle = document.querySelector('.ErrorBtn__title');
     if (errorBtnTitle) {
       // Create a new MouseEvent
       const event = new MouseEvent('click', {
         bubbles: true,    // The event bubbles up through the DOM
         cancelable: true, // The event can be canceled
         view: window      // The view that the event is associated with
       });

       // Dispatch the event on the element
       errorBtnTitle.dispatchEvent(event);
     }
// Call the original startNewChat function if it's provided
     if (startNewChat) {
       startNewChat();
     }
   };


  return (
    <>
      <button onClick={handleNewChatClick} className={`newChat ${collapsed ? 'collapsed' : ''}`} >
        <p>{newChatCaption}</p>
        <div>+</div>
      </button>
      <div className="ChatSelector__chats">
        <div className="slider">
          <div className="chats__title">
            <section className="chats__title__letters">
            <div></div>
            <div></div>
            </section>
            <span>Chat history</span>
          </div>
          <button
            onClick={toggleDaysVisibility}
            className={`svg_btn ${hideDays ? 'rotate' : ''}`}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="12"
              height="7"
              viewBox="0 0 12 7"
              fill="none"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M6.70711 6.70711C6.31658 7.09763 5.68342 7.09763 5.29289 6.70711L0.292893 1.70711C-0.0976315 1.31658 -0.0976315 0.683417 0.292893 0.292893C0.683417 -0.097631 1.31658 -0.097631 1.70711 0.292893L6 4.58579L10.2929 0.292893C10.6834 -0.097631 11.3166 -0.097631 11.7071 0.292893C12.0976 0.683417 12.0976 1.31658 11.7071 1.70711L6.70711 6.70711Z"
                fill="#040921"
              />
            </svg>
          </button>
        </div>
        <section className="daysScrollable">
          <div className={`day ${hideDays ? 'hide' : ''}`}>
            <div className="date">TODAY</div>
            <div className="date_text truncate-to-1-lines ">Help me re-balance my portfolio</div>
            <div className="date_text truncate-to-1-lines ">How is my portfolio performing?</div>
          </div>
          <div className={`day ${hideDays ? 'hide' : ''}`}>
            <div className="date">LAST WEEK</div>
            <div className="date_text truncate-to-1-lines ">Brief me about the market, focus me about the market</div>
            <div className="date_text truncate-to-1-lines ">Find me short term trading ideas</div>
            <div className="date_text truncate-to-1-lines ">Market, focus on my topics of</div>
            <div className="date_text truncate-to-1-lines ">AAPL vs TSLA using financial data me short term trading</div>
            <div className="date_text truncate-to-1-lines ">Brief me about the market, focus me about the market</div>
            <div className="date_text truncate-to-1-lines ">Find me short term trading ideas</div>
            <div className="date_text truncate-to-1-lines ">Market, focus on my topics of</div>
            <div className="date_text truncate-to-1-lines ">AAPL vs TSLA using financial data me short term trading</div>
            <div className="date_text truncate-to-1-lines ">Brief me about the market, focus me about the market</div>
            <div className="date_text truncate-to-1-lines ">Find me short term trading ideas</div>
            <div className="date_text truncate-to-1-lines ">Market, focus on my topics of</div>
            <div className="date_text truncate-to-1-lines ">AAPL vs TSLA using financial data me short term trading</div>
            
          </div>
        </section>
        {/* <hr /> */}
        <div className="separateLine"></div>
      </div>
    </>
  );
};

export default ChatSelector;
